import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
export const WIX_HP_REFERRAL = 'wix-hp';
export const useIsWixHpReferral = () => {
  var _getPremiumEssentials;
  return ((_getPremiumEssentials = getPremiumEssentialsSafe()) == null ? void 0 : _getPremiumEssentials.referralAdditionalInfo) === WIX_HP_REFERRAL;
};
//# sourceMappingURL=useIsWixHpReferral.js.map